/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useStyles } from "../styles";

interface BorderFrameProps {
  children: React.ReactNode;
}

const BorderFrame = ({ children }: BorderFrameProps) => {
  const { borderFrame } = useStyles();

  return <div css={css(borderFrame)}>{children}</div>;
};

export { BorderFrame };
